import { render, staticRenderFns } from "./PaymentMethodAmount.vue?vue&type=template&id=adfafbdc"
import script from "./PaymentMethodAmount.vue?vue&type=script&lang=js"
export * from "./PaymentMethodAmount.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodAmount.vue?vue&type=style&index=0&id=adfafbdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports